import React from 'react';

export const NoMatch = ({}) => {
  console.log('Implement me!');

  return <div style={{ width: '100%', height: '100%', backgroundColor: 'white' }}>not found.</div>;
};
